import { c as _c } from "react/compiler-runtime";
import { FileSelectorModal, FileSourceEnum, FileTypeEnum, FileUploaderItem, ImageCropperModalProps } from '@systemeio/file-manager';
import { FieldLabel, FieldLabelProps } from '@systemeio/ui';
import React, { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';
import { FieldErrorAndDescription } from '../form/field-error-and-description';
import { ImageUploader, Props as ImageUploaderProps } from './image-uploader';
interface Props extends FieldLabelProps, Pick<ImageUploaderProps, 'isSuccess' | 'statusIcon' | 'disabled' | 'isPreFetching'>, Pick<ImageCropperModalProps, 'allowSwitchingCroppingShape' | 'isRounded'> {
  value?: {
    path: string;
  } | null;
  source: FileSourceEnum;
  error?: string;
  labelImageUploader?: React.ReactNode;
  aspectRatio?: number;
  previewClassName?: string;
  dropZoneClassName?: string;
  className?: string;
  onSelect: ComponentProps<typeof FileSelectorModal>['onSelect'];
  onRemove: () => void;
}
export const ImageUploaderWithPreviewImage = t0 => {
  const $ = _c(37);
  const {
    value,
    source,
    error,
    label,
    labelImageUploader,
    required,
    aspectRatio: t1,
    labelClassName,
    previewClassName,
    dropZoneClassName,
    isPreFetching,
    disabled,
    isSuccess,
    statusIcon,
    className,
    onSelect,
    onRemove,
    isRounded,
    allowSwitchingCroppingShape
  } = t0;
  const aspectRatio = t1 === undefined ? NaN : t1;
  let t2;
  if ($[0] !== className) {
    t2 = twMerge("flex flex-col gap-1", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label || $[3] !== labelClassName || $[4] !== required) {
    t3 = <FieldLabel label={label} required={required} labelClassName={labelClassName} />;
    $[2] = label;
    $[3] = labelClassName;
    $[4] = required;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== disabled || $[7] !== error || $[8] !== isPreFetching || $[9] !== onRemove || $[10] !== previewClassName || $[11] !== statusIcon || $[12] !== value) {
    t4 = value && <div className={twMerge("w-fit", statusIcon && "relative")}><FileUploaderItem file={{
        id: 0,
        path: value.path,
        size: 0,
        type: FileTypeEnum.Image,
        filename: "",
        thumbnail: value.path
      }} showDeleteButton={true} className={previewClassName} onDeleteFile={onRemove} disabled={isPreFetching || disabled} />{statusIcon && <div className="absolute left-2 top-2">{statusIcon}</div>}<FieldErrorAndDescription error={error} /></div>;
    $[6] = disabled;
    $[7] = error;
    $[8] = isPreFetching;
    $[9] = onRemove;
    $[10] = previewClassName;
    $[11] = statusIcon;
    $[12] = value;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const t5 = !value;
  let t6;
  if ($[14] !== aspectRatio) {
    t6 = {
      aspectRatio
    };
    $[14] = aspectRatio;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== allowSwitchingCroppingShape || $[17] !== isRounded || $[18] !== t6) {
    t7 = {
      allowSwitchingCroppingShape,
      isRounded,
      imageCropperProps: t6
    };
    $[16] = allowSwitchingCroppingShape;
    $[17] = isRounded;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== disabled || $[21] !== dropZoneClassName || $[22] !== error || $[23] !== isPreFetching || $[24] !== isSuccess || $[25] !== labelImageUploader || $[26] !== onSelect || $[27] !== source || $[28] !== statusIcon || $[29] !== t5 || $[30] !== t7) {
    t8 = <ImageUploader showDropZone={t5} label={labelImageUploader} source={source} onSelect={onSelect} error={error} dropZoneClassName={dropZoneClassName} imageCropperModalProps={t7} isPreFetching={isPreFetching} disabled={disabled} isSuccess={isSuccess} statusIcon={statusIcon} />;
    $[20] = disabled;
    $[21] = dropZoneClassName;
    $[22] = error;
    $[23] = isPreFetching;
    $[24] = isSuccess;
    $[25] = labelImageUploader;
    $[26] = onSelect;
    $[27] = source;
    $[28] = statusIcon;
    $[29] = t5;
    $[30] = t7;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  let t9;
  if ($[32] !== t2 || $[33] !== t3 || $[34] !== t4 || $[35] !== t8) {
    t9 = <div className={t2}>{t3}{t4}{t8}</div>;
    $[32] = t2;
    $[33] = t3;
    $[34] = t4;
    $[35] = t8;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  return t9;
};